import React, { useEffect, useState } from 'react';
import api from '../utils/api';

// Module-level cache so the grouped category list is fetched only once per session.
let groupsCache = null;
const subscribers = [];

function loadGroups() {
  if (groupsCache) return Promise.resolve(groupsCache);
  return api.get('/contributions/category-groups').then(r => {
    groupsCache = r.data;
    subscribers.forEach(fn => fn(groupsCache));
    return groupsCache;
  });
}

// A grouped <select> of the official contribution categories, with each option
// labelled by its Small–Large point range. Pass `groups` to reuse an already
// fetched list, or omit to let the component fetch (and cache) them.
export default function CategorySelect({ value, onChange, groups: groupsProp, showPoints = true, id, required }) {
  const [groups, setGroups] = useState(groupsProp || groupsCache || []);

  useEffect(() => {
    if (groupsProp) { setGroups(groupsProp); return undefined; }
    let active = true;
    loadGroups().then(g => { if (active) setGroups(g); }).catch(() => {});
    return () => { active = false; };
  }, [groupsProp]);

  return (
    <select id={id} className="input" value={value} required={required} onChange={e => onChange(e.target.value)}>
      <option value="">Select a category…</option>
      {groups.map(g => (
        <optgroup key={g.group} label={g.group}>
          {g.categories.map(c => (
            <option key={c.name} value={c.name}>
              {c.name}{showPoints ? `  ·  ${c.points.S.toLocaleString()}–${c.points.L.toLocaleString()} pts` : ''}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}

// Helper for callers that need the flat name -> {S,M,L} lookup (e.g. live point calc).
export function flattenGroups(groups) {
  const map = {};
  (groups || []).forEach(g => g.categories.forEach(c => { map[c.name] = c.points; }));
  return map;
}
